module.exports = __webpack_public_path__ + "static/media/sur_medio(1).bb040739.jpg";